import Model from './model';

import { datify, fmt, unixts } from '../utils/date';





export default Model.extend( {

    endpoint: 'timetables?apiVersion=2.0',

    defaults() {
        return {
            title: '',
            time_zone: null,
            worktime: null,
            cluster: null,
            contract: null,
            organization: null,
            start_date_time: null,
            finish_date_time: null,
            on: true,
            weekdays: [
                {
                    on: true,
                    times: [],
                    periods_months: [],

                    weekly_patterns: [
                        {
                            on: true,
                            value: [],
                        }
                    ],

                    monthly_patterns: [
                        {
                            on: true,
                            value: [],
                        }
                    ],

                    random_patterns: [
                        {
                            on: true,
                            value: [],
                        }
                    ],

                    yearly_patterns: [
                        {
                            on: true,
                            value: [],
                        }
                    ],
                }
            ],
            holidays: [
                {
                    on: true,

                    weekly_patterns: [
                        {
                            on: true,
                            value: [],
                        }
                    ],

                    monthly_patterns: [
                        {
                            on: true,
                            value: [],
                        }
                    ],

                    random_patterns: [
                        {
                            on: true,
                            value: [],
                        }
                    ],

                    yearly_patterns: [
                        {
                            on: true,
                            value: [],
                        }
                    ],
                }
            ]
        };
    },

    customParser({ weekdays, holidays, ...payload }) {
        // suppose we cannot eliminate patterns 
        // in weekdays/holidays to []

        if (weekdays && !weekdays.length)
            weekdays = null;

        if (holidays && !holidays.length)
            holidays = null;

        const attrs = {

            weekdays: weekdays || [{
                on: true,
                times: [],
                periods_months: [],

                weekly_patterns: [
                    {
                        on: true,
                        value: [],
                    }
                ],

                monthly_patterns: [
                    {
                        on: true,
                        value: [],
                    }
                ],

                random_patterns: [
                    {
                        on: true,
                        value: [],
                    }
                ],

                yearly_patterns: [
                    {
                        on: true,
                        value: [],
                    }
                ],
            }],

            holidays: holidays || [{
                on: true,
                times: [],
                periods_months: [],

                weekly_patterns: [
                    {
                        on: true,
                        value: [],
                    }
                ],

                monthly_patterns: [
                    {
                        on: true,
                        value: [],
                    }
                ],

                random_patterns: [
                    {
                        on: true,
                        value: [],
                    }
                ],

                yearly_patterns: [
                    {
                        on: true,
                        value: [],
                    }
                ],
            }],

            ...payload

        };

        const checkPattern = patternArray => 
            patternArray && !patternArray.length && patternArray.push( {
                on: true,
                value: [],
            } );
        const checkPatterns = day => {
            checkPattern( day.weekly_patterns );
            checkPattern( day.monthly_patterns );
            checkPattern( day.yearly_patterns );
            checkPattern( day.random_patterns );
        };
        const checkDays = days => 
            days && days.forEach( checkPatterns );

        checkDays( attrs.weekdays );
        checkDays( attrs.holidays );

        const commonCmp = (x, y) => x < y ? -1 : x > y ? 1 : 0;
        const dateSplit = ddmmyyyy => ddmmyyyy.split( '.' ).reverse();
        const dateCmp = (x, y) => commonCmp( dateSplit( x ), dateSplit( y ) );
        const objCmp = (a, b) => commonCmp( a.id, b.id );

        const sortFn = group => {
            group.monthly_patterns
                .forEach( p => p.value.sort( (x, y) => x - y ) );
            group.yearly_patterns
                .forEach( p => p.value.sort( dateCmp ) );
            group.random_patterns
                .forEach( p => p.value.sort( dateCmp ) );
            group.weekly_patterns.sort( objCmp );
            group.monthly_patterns.sort( objCmp );
            group.yearly_patterns.sort( objCmp );
            group.random_patterns.sort( objCmp );
        };

        return attrs.weekdays.map( sortFn ),
            attrs.holidays.map( sortFn ),
            attrs.weekdays.sort( objCmp ),
            attrs.holidays.sort( objCmp ),
            attrs;
    },

    clonePattern(pattern) {
        const cloneFn = (groups, patternsPropName) => {
            const searchingPattern = groups
                .map( (group, index ) => 
                    [index, group[patternsPropName].findIndex( p => p === pattern )] )
                .filter( ([_, patternIndex]) => ~patternIndex );
            if (!searchingPattern.length)
                return;

            const [[groupIndex, patternIndex]] = searchingPattern;

            return clonePattern.call( this,
                groups,
                groupIndex,
                patternIndex,
                patternsPropName );
        };

        const f = groups =>
            cloneFn( groups, 'random_patterns' ) ||
            cloneFn( groups, 'yearly_patterns' ) ||
            cloneFn( groups, 'monthly_patterns' ) ||
            cloneFn( groups, 'weekly_patterns' )

        return f( this.get( 'weekdays' ) ) || f ( this.get( 'holidays' ) );
    },

} );





function clonePattern(groups, groupIndex, patternIndex, patternProperty) {
    const newGroups = [...groups]; 

    if (!newGroups[groupIndex])
        return;
    const group = newGroups[groupIndex] 
        = { ...newGroups[groupIndex] };

    if (!group[patternProperty])
        return;
    const patterns = group[patternProperty]
        = [...group[patternProperty]];

    if (!patterns[patternIndex])
        return;
    const pattern = patterns[patternIndex] 
        = { ...patterns[patternIndex] };

    return { 
        pattern,
        [groups == this.get( 'weekdays' ) ? 'weekdays' : 'holidays']: newGroups
     };
}


// WEBPACK FOOTER //
// ./src/js/model/schedule.js